import Button from '@restart/ui/esm/Button';
import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';

import foodi1 from '../../../img/foodie/foodie1.png'
import Foodie from './Foodie';
import './Myworks.css';
import doctor1 from '../../../img/doctors-care/doctor1.png';
import Doctor from './Doctor';
import Sunglass from './Sunglass';
import sunglass1 from '../../../img/sunglass/sunglass1.png'

const Myworks = () => {

  const [modalShow, setModalShow] = React.useState(false);



    return (
      <Container>
      <Row>
      <Col className='p-2' xs={12} md={6} > 
<div style={{color:'#ffffff'}}>
           <Card >
            <Card.Img src={foodi1} alt="foodi1 image" />
            <Card.ImgOverlay>
              <br/>  <br/>  <br/>
              <Card.Title className="text-center">Foodie Portal</Card.Title>
              <Card.Text  >
              <ol className='text pl-4'>
                <li>	With an authentic server site.</li>
                <li>	A Food website portal.</li>
                <li>User can choose their Food.</li>
              </ol>

              </Card.Text>
            
              <Card.Body className='p-0'>
              <>
                  <Button className="button  " variant="primary" onClick={() => setModalShow(true)}>
                    Project Details
                  </Button>
            {/* MyVerticallyCenteredModal */}
                  <Foodie
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                  />
                </>
              
            </Card.Body>
            </Card.ImgOverlay>
          </Card>
</div>
        </Col>
     
        <Col className='p-2' xs={12} md={6} > 
        <div style={{color:'#ffffff'}}>
  <Card >
  <Card.Img src={doctor1} alt="doctor1 image" />
  <Card.ImgOverlay>
    <br/>  <br/>  <br/>
    <Card.Title className="text-center">Doctors-Care Portal</Card.Title>
    <Card.Text  >
    <ol className='text pl-4'>
      <li>	Healthcare related website.</li>
      <li>Client can booking services.</li>
      <li>Google authentication Enable.</li>
    </ol>

    </Card.Text>
   
    <Card.Body className='p-0'>
    <>
        <Button className="button  " variant="primary" onClick={() => setModalShow(true)}>
          Project Details
        </Button>
  {/* MyVerticallyCenteredModal */}
        <Doctor
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </>
    
  </Card.Body>
  </Card.ImgOverlay>
</Card>
</div>

        </Col>
      </Row>
       <Row>
       <Col className='p-2' xs={12} md={6} > 
        <div style={{color:'#ffffff'}}>
  <Card >
  <Card.Img src={sunglass1} alt="doctor1 image" />
  <Card.ImgOverlay>
    <br/>  <br/>  <br/>
    <Card.Title className="text-center">Glasses-Revaluation </Card.Title>
    <Card.Text  >
    <ol className='text pl-4'>
      <li>User and Admin Panal Included.</li>
      <li>User can get glasses.</li>
      <li>Authentication Enable.</li>
    </ol>

    </Card.Text>
   
    <Card.Body className='p-0'>
    <>
        <Button className="button  " variant="primary" onClick={() => setModalShow(true)}>
          Project Details
        </Button>
  {/* MyVerticallyCenteredModal */}
        <Sunglass
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </>
    
  </Card.Body>
  </Card.ImgOverlay>
</Card>
</div>

        </Col>
        
        <Col className='p-2' xs={12} md={6} > 
        <div >
  <Card >
 
<h1 className='button p-4 '>New project coming.........</h1>

<Button className='button  m-2'><a style={{textDecoration:'none'}} href='https://github.com/Dipctg' >Almost projects cooking here.......
<br/>
Click Here For More Details.</a> </Button>
</Card>
</div>

        </Col>
      </Row> 
    </Container>
    );
};

export default Myworks;